import React from "react";
import styled from "styled-components";
import ButtonLink from "./ButtonLink";
import Logo from "./Logo";
import { AiTwotoneHome, AiTwotoneSetting } from "react-icons/ai";
import { BsFillPersonFill } from "react-icons/bs";
import { HiCode } from "react-icons/hi";
import { MdContacts } from "react-icons/md";
import { CgMenuGridO } from "react-icons/cg";

const HeaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0);
  box-shadow: 0 5px 35px rgba(0, 0, 0, 0.7);
  width: 100%;
  padding: 10px;
  position: fixed;
  top: 0;
  left: 0;
  overflow: hidden;
  background-color: var(--background-color-main);
  z-index: 10000;
`;
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  flex: 0.7;

  @media only screen and (max-width: 560px) {
    display: none;
  }
`;

const MenuButton = styled.div`
  display: none;
  align-items: center;
  justify-content: center;
  font-size: 30px;
  -webkit-box-reflect: below 0px linear-gradient(#0000, #0002);
  cursor: pointer;

  @media only screen and (max-width: 560px) {
    display: flex;
  }
`;
function Header({ toggleNav }) {
  return (
    <HeaderStyled>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <Nav>
        <ButtonLink text={"Home"} icon={<AiTwotoneHome />} Id={"home"} />
        <ButtonLink text={"About"} icon={<BsFillPersonFill />} Id={"about"} />
        <ButtonLink text={"Skills"} icon={<AiTwotoneSetting />} Id={"skills"} />
        <ButtonLink text={"Projects"} icon={<HiCode />} Id={"projects"} />
        <ButtonLink text={"Contact"} icon={<MdContacts />} Id={"contact"} />
      </Nav>
      <MenuButton onClick={toggleNav}>
        <CgMenuGridO />
      </MenuButton>
    </HeaderStyled>
  );
}

export default Header;
